var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckXs = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.0996 8.29524C5.51011 7.92578 6.1424 7.95906 6.51186 8.36957L7.12528 9.05115L9.74891 5.62631C10.0848 5.18788 10.7125 5.10473 11.1509 5.44059C11.5893 5.77645 11.6724 6.40413 11.3366 6.84256L7.98101 11.2229C7.80021 11.4589 7.52378 11.6022 7.22671 11.614C6.92965 11.6257 6.64275 11.5047 6.44387 11.2837L5.02527 9.7075C4.65581 9.29699 4.68909 8.6647 5.0996 8.29524ZM8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
  fill: "currentColor"
})));
export { SvgCheckXs as ReactComponent };